import React from 'react';
import { useQuery } from '@tanstack/react-query';

import { locationsQuery } from '@queries';

import SortableSelect from './SortableSelect/SortableSelect.jsx';

export const LocationsFieldField = ({ field, allLocationsData }) => {
  const allLocationOptions = allLocationsData.map((location) => {
    return {
      value: location.id,
      label: location.location_name || location.formatted_address,
    };
  });

  return (
    <SortableSelect
      name={field.name}
      inputRef={field.ref}
      options={allLocationOptions}
      isClearable={true}
      className="basic-multi-select"
      classNamePrefix="select"
      onChange={(val) => {
        console.log('onChange', val);
        field.onChange(val.map((v) => v.value));
      }}
      fieldValue={field.value}
    />
  );
};

// wrapper around the field so we dont render the field
// until we try to load all the defaultLocations first
//
// might be able to refactor in future to remove this requirement
export const LocationsField = ({
  field,
  businessID,
  defaultLocations = [],
}) => {
  const { data: allLocationsData, isPending: allLocationsIsPending } = useQuery(
    locationsQuery({
      business_id: businessID,
      limit: 1000,
      order_by: 'location_name',
      _fields: ['id', 'location_name', 'formatted_address'].join(','),
    }),
  );

  return (
    <>
      {allLocationsData &&
        (defaultLocations.length === 0 || !allLocationsIsPending) && (
          <LocationsFieldField
            field={field}
            allLocationsData={allLocationsData.objects}
          />
        )}
    </>
  );
};
